@if (rbList) {
<div class="right-block screen">
  <div class="widget-body">
    <div
      class="widget-toolbox"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <button mat-button (click)="onNavigateRulebook('previous')">
        <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon>
        Previous
      </button>
      <button mat-button class="reverse-icon-button" (click)="onNavigateRulebook('next')">
        Next<mat-icon aria-hidden="true" aria-label="Next"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
    <div class="widget-main">
      @for (ac of rbList; track ac) {
      <ul class="nav-list">
        @for (tpc of ac.topics; track tpc) {
        <ul class="sub-menu" fxLayout="row" fxLayoutAlign="start start">
          <li class="sub-menu">
            <span class="heavy"
              >{{ ac.acronym }}<mat-icon class="hh">chevron_right</mat-icon
              >{{ tpc.topic }}</span
            >
            @for (rb of tpc.rulebooks; track rb) { @if (rb.checkNa == false) {
            <ul class="sub-item">
              <div
                fxLayout="row"
                [ngClass]="{ active: rb.rbKey == this.selected }"
              >
                <span
                  fxFlex="92"
                  class="text-inside-list"
                  (click)="onClickRulebook(rb.rbKey, rb.rbName)"
                  >{{ decodeHtml(rb.rbName) }}</span
                >
                @if (rb.rbKey == this.selected) {
                <mat-icon
                  fxFlex="8"
                  aria-hidden="true"
                  aria-label="Next"
                  class="active"
                  >grade</mat-icon
                >
                }
              </div>
            </ul>
            } }
          </li>
        </ul>
        }
      </ul>
      }
    </div>
    <div
      class="widget-toolbox"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <button mat-button (click)="onNavigateRulebook('previous')">
        <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon
        >Previous
      </button>
      <button mat-button class="reverse-icon-button" (click)="onNavigateRulebook('next')">
        Next<mat-icon aria-hidden="true" aria-label="Next"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
  </div>
</div>
}
